var _path, _rect, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlbumIconCreate(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 22.6856V10.3469H30.1733V22.7845C30.1733 27.872 26.9709 31 21.8472 31H9.31006C4.23436 31 1 27.8071 1 22.6856ZM11.3816 19.3834C12.8701 19.3834 14.0816 18.1719 14.0816 16.6834C14.0816 15.1949 12.8701 13.9823 11.3816 13.9823C9.89197 13.9823 8.68159 15.1949 8.68159 16.6834C8.68159 18.1719 9.89197 19.3834 11.3816 19.3834ZM23.4967 21.7682C23.3772 21.4694 23.1957 21.1891 22.9426 20.9435C22.2787 20.3014 21.6583 19.7016 20.9206 19.2583C19.7634 18.5543 18.8681 19.543 18.6269 19.8592C18.4325 20.1145 18.2608 20.3919 18.0865 20.6735L18.0865 20.6735C18.0524 20.7287 18.0182 20.7839 17.9837 20.8392L17.9734 20.8559C17.4608 21.6821 16.8719 22.6314 15.8574 23.1861C14.3732 23.9858 13.2465 23.2491 12.436 22.7124C12.1317 22.5125 11.8362 22.3223 11.5418 22.1963C10.816 21.891 10.163 22.2387 9.1938 23.4382C8.68531 24.0651 8.18116 24.6866 7.6705 25.3059C7.36519 25.6775 7.43799 26.2479 7.84978 26.4956C8.50712 26.8911 9.30897 27.1019 10.2151 27.1019H19.3212C19.8351 27.1019 20.3502 27.0345 20.8413 26.877C21.9473 26.525 22.8252 25.7199 23.2837 24.654C23.6705 23.7587 23.8585 22.6722 23.4967 21.7682Z",
    fill: "#7C85AF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.10376,
    y: 5.06824,
    width: 12.9659,
    height: 2.43111,
    rx: 1.21555,
    fill: "#7C85AF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1.00562 10.3468C1.02643 9.39542 1.10649 7.50726 1.257 6.89948C2.02556 3.48135 4.63546 1.30956 8.36618 1H22.8087C26.5074 1.32577 29.1493 3.51214 29.9179 6.89948C30.0668 7.49105 30.1469 9.3938 30.1677 10.3468H1.00562Z",
    fill: "#7C85AF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlbumIconCreate);
export default __webpack_public_path__ + "static/media/album-icon-create.250f43080499b15ff4f77cef9ec16e38.svg";
export { ForwardRef as ReactComponent };